module.exports = __webpack_public_path__ + "static/media/plaza-1-mobile.e88314c7.webp";